// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const tynamo: PokeData = {
  "id": 602,
  "name": "tynamo",
  "height": 2,
  "weight": 3,
  "base_experience": 55,
  "types": [
    PokeType.ELECTRIC
  ],
  "api_moves": [
    "tackle",
    "thunder-wave",
    "spark",
    "charge-beam"
  ],
  "moves": [
    "tackle",
    "zap-cannon",
    "thunder-punch",
    "thunder-fang",
    "wild-charge",
    "thunder",
    "electric-wrath",
    "quick-tempo",
    "electric-terrain",
    "volt-switch",
    "thunderbolt",
    "volt-crash",
    "thunder-shock"
  ],
  "evolution_chain": {
    "id": 306,
    "item": null,
    "species": [
      {
        "name": "tynamo",
        "order": 603,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "eelektrik",
        "order": 604,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": 602,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 39,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "eelektross",
        "order": 605,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": 603,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "thunder-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 37.5,
    "speed": 60,
    "ability_power": 55
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
